import React from 'react';
import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Dancers from './components/Dancers';
import Tour from './components/Tour';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <Dancers />
      <Tour />
      <Footer />
    </div>
  );
}

export default App;
